import { get } from 'lodash';
import { createPropsSelectorOrm } from '../utils';

export const getParcelEvents = createPropsSelectorOrm((session, parcelCode) =>
  get(session.Event.withId(parcelCode), 'ref.items')
);
